/**
 *  用户相关 API 地址
 *  @swagger http://bp-partner-bff.t-sy-in.earth.xcloud.lenovo.com/swagger-ui.html
 */
import { IAjaxConfig } from '../helpers';
export class EnumApiPartner {
  /**
   * @method get 根据身份id查询企业身份详情
   * @params
   */
  readonly partner_partnerIdentity_findInfo: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerIdentity/findCurrentPartnerIdentity',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @method get 根据身份id查询企业身份详情 (新，合并l2后)
   * @params
   */
  readonly partner_partnerIdentity_findInfo_new: IAjaxConfig = {
    url: '/api/gateway/partner-bff/v3/api/partnerIdentity/findCurrentPartnerIdentity',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @method get 获取当前身份信息
   * @params
   */
  readonly partner_get_identity_info: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerIdentity/findUserIdAndIdentityByToken',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @method get 获取当前身份下的角色
   * @params
   */
  readonly partner_get_identity_role: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerEmployeeRelation/findUserChannelRoleContent',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @method get 根据输入的K查询企业身份
   * @params
   */
  readonly partner_partnerIdentity: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerIdentity/findChannelPartnerIdentity',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec
   * @method post 加入组织申请提交
   * @params
   */
  readonly partner_partnerIdentityCreate: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/employeeApplyIdentity/create',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec
   * @method post 获取身份list
   * @params
   */
  readonly partner_get_partnerIdentity: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerIdentity/listChannelByUserId4Choice',
    method: 'get',
    loading: true,
    // awaitAuthenticated: false,
  };

  /**
   * @dec
   * @method post 获取身份list(新，合并l2后)
   * @params
   */
  readonly partner_get_partnerIdentity_new: IAjaxConfig = {
    url: '/api/gateway/partner-bff/v3/api/partnerIdentity/listChannelByUserId4Choice',
    method: 'get',
    loading: true,
    // awaitAuthenticated: false,
  };

  /**
   * @dec
   * @method get 获取角色
   * @params
   */
  readonly partner_get_role: IAjaxConfig = {
    url: '/api/gateway/permission/role/search',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 申请身份
   * @method post
   * @params
   */
  readonly partner_applyIdentity_create: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerApplyIdentity/create',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 已有合作身份列表
   * @method get
   * @params
   */
  readonly partner_have_identityList: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerApplyIdentity/listExcludeIdentity',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 合作身份列表
   * @method get
   * @params
   */
  readonly partner_identityListAll: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/identityCodeTable/listIdentityCodeTableShow',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @dec 根据身份ID查询当前身份id的BU
   * @method get
   * @params
   */
  readonly partner_findBuByIdentityId: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/partnerIdentity/findBuByIdentityId',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };

  /**
   * @dec 获取审批人信息
   * @method get
   * @params
   */
  readonly partner_get_employeeApplyIdentity: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/employeeApplyIdentity/getChannelContactsById',
    method: 'get',
  };
  /**
   * @dec SMB加入组织
   */
  readonly partner_serviceStation_smbJoinOrg: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/employeeApplyIdentity/create4smb',
    method: 'get',
  };

  /**
   * @dec 获取sales信息
   * @method get
   * @params
   */
  readonly partner_getSales_userinfo: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/inside/userInfo',
    method: 'get',
  };
}
